import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import {MaterialModule} from '../material/material.module';
import { LoaderComponent } from './loader/loader.component';
import {RouterModule} from '@angular/router';
import {FooterComponent} from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DirectivesModule} from '../directives/directives.module';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {_MatMenuDirectivesModule, MatMenuModule} from '@angular/material/menu';
import {TranslateModule} from '@ngx-translate/core';
import {NgxSpinnerModule} from 'ngx-spinner';
import {PaymentGatewayComponent} from './modals/payment-gateway/payment-gateway.component';
import { SignatureCaptureComponent } from './signature-capture/signature-capture.component';
import { CardCollectComponent } from './modals/card-collect/card-collect.component';
import { UserNotificationsModalComponent } from './modals/user-notifications-modal/user-notifications-modal.component';
import { UserListComponent } from './list/user-list/user-list.component';
import { GroupFormComponent } from './modals/group-form/group-form.component';
import { AddUserGroupComponent } from './modals/add-user-group/add-user-group.component';
import { UserNotificationsListComponent } from './list/user-notifications-list/user-notifications-list.component';
import { UserFoodsListComponent } from './list/user-foods-list/user-foods-list.component';
import { UserFoodsModalComponent } from './modals/user-foods-modal/user-foods-modal.component';
import { UserBodyModalComponent } from './modals/user-body-modal/user-body-modal.component';
import { UserBodyListComponent } from './list/user-body-list/user-body-list.component';
import { UserProfileComponent } from './modals/user-profile/user-profile.component';



@NgModule({
  declarations: [
    SidebarComponent,
    LoaderComponent,
    FooterComponent,
    NavbarComponent,
    PaymentGatewayComponent,
    SignatureCaptureComponent,
    CardCollectComponent,
    UserListComponent,
    GroupFormComponent,
    AddUserGroupComponent,
    UserNotificationsListComponent,
    UserNotificationsModalComponent,
    UserFoodsListComponent,
    UserFoodsModalComponent,
    UserBodyModalComponent,
    UserBodyListComponent,
    UserProfileComponent
  ],
  exports: [
    SidebarComponent,
    LoaderComponent,
    FooterComponent,
    NavbarComponent,
    PaymentGatewayComponent,
    SignatureCaptureComponent,
    UserListComponent,
    GroupFormComponent,
    AddUserGroupComponent,
    UserNotificationsListComponent,
    UserNotificationsModalComponent,
    UserFoodsListComponent,
    UserFoodsModalComponent,
    UserBodyModalComponent,
    UserBodyListComponent,
    UserProfileComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatSlideToggleModule,
    DirectivesModule,
    _MatMenuDirectivesModule,
    MatMenuModule,
    TranslateModule,
    NgxSpinnerModule
  ],
  entryComponents: [
    PaymentGatewayComponent,
    SignatureCaptureComponent,
    UserListComponent,
    GroupFormComponent,
    AddUserGroupComponent,
    UserNotificationsListComponent,
    UserNotificationsModalComponent,
    UserFoodsListComponent,
    UserFoodsModalComponent,
    UserBodyModalComponent,
    UserBodyListComponent,
    UserProfileComponent
  ]
})
export class AppCommonModule { }
